"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _BizObjectives = _interopRequireDefault(require("self-service-api/constants/BizObjectives"));

var _Features = _interopRequireDefault(require("self-service-api/constants/Features"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _UICardGrid = _interopRequireDefault(require("UIComponents/card/UICardGrid"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _CMS_HUB_MARKETING_ST;

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: left;\n    padding-left: 0;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 19px;\n  height: 20px;\n  margin-bottom: 10px;\n  text-align: left;\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    color: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 700 !important;\n  text-transform: uppercase;\n  margin-left: 0 !important;\n  margin-bottom: 4px !important;\n  font-size: 13px;\n  color: ", " !important;\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    > div {\n      grid-template-columns: 1fr;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding-left: 0;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", ";\n  min-height: 300px;\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BizObjectivesContainer = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundleBizObjectives__BizObjectivesContainer",
  componentId: "sc-1yxo941-0"
})(_templateObject(), function (props) {
  return props.inSingleColumnPriceDisplay ? '28px 40px 40px !important' : '60px';
}, _responsiveBreakpoints.default.tablet(_templateObject2()), _responsiveBreakpoints.default.tabletPortrait(_templateObject3()));

var Header = _styledComponents.default.h6.withConfig({
  displayName: "CmsMarketingBundleBizObjectives__Header",
  componentId: "sc-1yxo941-1"
})(_templateObject4(), _colors.CALYPSO_DARK, _responsiveBreakpoints.default.tablet(_templateObject5(), _colors.CALYPSO_DARK));

var LowerTierSubtext = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundleBizObjectives__LowerTierSubtext",
  componentId: "sc-1yxo941-2"
})(_templateObject6(), _responsiveBreakpoints.default.tablet(_templateObject7()));

var CMS_HUB_MARKETING_STARTER_BIZ_OBJECTIVES = (_CMS_HUB_MARKETING_ST = {}, (0, _defineProperty2.default)(_CMS_HUB_MARKETING_ST, _BizObjectives.default.CREATE_ENGAGING_CONTENT, {
  features: [_Features.default.WEBSITE_PAGES, _Features.default.LANDING_PAGES, _Features.default.BLOG, _Features.default.DRAG_AND_DROP_EDITOR]
}), (0, _defineProperty2.default)(_CMS_HUB_MARKETING_ST, _BizObjectives.default.ENGAGE_LEADS, {
  features: [_Features.default.EMAIL_MARKETING, _Features.default.AD_RETARGETING, _Features.default.MESSENGER_INTEGRATION]
}), (0, _defineProperty2.default)(_CMS_HUB_MARKETING_ST, _BizObjectives.default.CAPTURE_CONVERT_LEADS_CMS, {
  features: [_Features.default.LIVE_CHAT, _Features.default.CONVERSATIONAL_BOTS, _Features.default.FORMS]
}), (0, _defineProperty2.default)(_CMS_HUB_MARKETING_ST, _BizObjectives.default.UNDERSTAND_LEADS, {
  features: [_Features.default.CONTACT_ATTRIBUTION_REPORT_BUILDER, _Features.default.LIST_SEGMENTATION, _Features.default.WEBSITE_TRAFFIC_ANALYSIS]
}), (0, _defineProperty2.default)(_CMS_HUB_MARKETING_ST, _BizObjectives.default.GET_FOUND_ONLINE_MARKETING, {
  features: [_Features.default.SEO_RECOMMEND_OPTIMIZE, _Features.default.BUILT_IN_AMP_SUPPORT, _Features.default.GOOGLE_SEARCH_CONSOLE_INTEGRATION]
}), (0, _defineProperty2.default)(_CMS_HUB_MARKETING_ST, _BizObjectives.default.PERSONALIZE_EXPERIENCES, {
  features: [_Features.default.CALLS_TO_ACTION, _Features.default.SMART_CONTENT_AND_REPORTING]
}), _CMS_HUB_MARKETING_ST);

var CmsMarketingBundleBizObjectives = function CmsMarketingBundleBizObjectives(_ref) {
  var hub = _ref.hub;
  var BizObjectivesMap = CMS_HUB_MARKETING_STARTER_BIZ_OBJECTIVES;

  var renderFeature = function renderFeature(feature) {
    return _react.default.createElement(_UITooltip.default, {
      key: feature,
      placement: "right",
      title: _react.default.createElement(_FormattedMessage.default, {
        message: (0, _getFeatureDescriptionKey.default)(feature, hub)
      })
    }, _react.default.createElement("div", {
      className: "display-block m-y-1"
    }, _react.default.createElement(_UIIcon.default, {
      className: "m-right-3",
      color: _colors.OBSIDIAN,
      name: "success"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "pricing-pages.features." + feature + ".name"
    })));
  };

  var renderBizObjective = function renderBizObjective(bizObjKey) {
    var features = BizObjectivesMap[bizObjKey].features;
    return _react.default.createElement("div", {
      key: bizObjKey
    }, _react.default.createElement(Header, null, _react.default.createElement(_FormattedMessage.default, {
      message: "pricing-pages.bizObjectives." + bizObjKey
    })), features.map(renderFeature));
  };

  return _react.default.createElement(BizObjectivesContainer, {
    "data-selenium-id": "cms-marketing-biz-objectives"
  }, _react.default.createElement(LowerTierSubtext, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.hubTiers.starter.lowerTierPlus"
  })), _react.default.createElement("div", null, _react.default.createElement(_UICardGrid.default, {
    columns: 2
  }, Object.keys(BizObjectivesMap).map(renderBizObjective))));
};

var _default = CmsMarketingBundleBizObjectives;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/CmsMarketingBundleBizObjectives.js
// module id = 849
// module chunks = 5 6